import Affiliate from './Affiliate';
import PHPCookie from './PHPCookie';

export default class Facebook extends Affiliate {
  constructor() {
    super();
    this.affiliateName = 'facebookads';
    this.cookieDomain = new PHPCookie();
    this.cookieNames = ['serverToServerAffiliate', 'serverToServerClickId', 'serverToServerBrowserId'];
  }

  prepareCookie() {
    const { fbclid } = this.urlParams;
    const cookie = {};
    document.cookie.split(';').forEach((el) => {
      const [k, v] = el.split('=');
      cookie[k.trim()] = v;
    });

    this.cookieDomain.sendCookie({ name: 'serverToServerBrowserId', value: cookie._fbp, httponly: 1 })
      .then(this.cookieDomain.sendCookie({ name: 'serverToServerClickId', value: `fb.1.${Date.now()}.${fbclid}`, httponly: 1 })
        .then(this.cookieDomain.sendCookie({ name: 'serverToServerAffiliate', value: 'facebookads', httponly: 1 })));
  }
}



// WEBPACK FOOTER //
// ./src/Common/Helpers/TrackingAffiliate/Facebook.js